// Community Gas Management APIs

/**
 * @function ApiClient#AddGasForm
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} month
 * @param {any} endTime
 * @param {any} options = {}
 */
export async function AddGasForm(cid, month, endTime, options = {}) {
  return await this._post(`/community/${cid}/gas?m=${month}&et=${endTime}`, null, options);
}

/**
 * @function ApiClient#UpdateGasForm
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fid
 * @param {any} month
 * @param {any} endTime
 * @param {any} options = {}
 */
export async function UpdateGasForm(cid, fid, month, endTime, options = {}) {
  return await this._put(`/community/${cid}/gas/${fid}?m=${month}&et=${endTime}`, null, options);
}

/**
 * @function ApiClient#DeleteGasForm
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fid
 * @param {any} options = {}
 */
export async function DeleteGasForm(cid, fid, options = {}) {
  return await this._delete(`/community/${cid}/gas/${fid}`, options);
}

/**
 * @function ApiClient#GetGasFormList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.month
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} options = {}
 */
export async function GetGasFormList(cid, { month, sortBy, sortDesc, page, itemsPerPage }, options = {}) {
  if (!month) month = "";

  return await this._get(`/community/${cid}/gas_list?m=${month}&p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}`, options);
}

/**
 * @function ApiClient#NotifyGasForm
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fid
 * @param {any} options = {}
 */
export async function NotifyGasForm(cid, fid, options = {}) {
  return await this._post(`/community/${cid}/gas/${fid}/notify`, null, options);
}

/**
 * @function ApiClient#GetGasDataList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fid
 * @param {any} options = {}
 */
export async function GetGasDataList(cid, fid, options = {}) {
  return await this._get(`/community/${cid}/gas/${fid}/list`, options);
}

/**
 * @function ApiClient#SetGasDataUseValue
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fid
 * @param {object} params 參數。
 * @param {any} params.useValue
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} options = {}
 */
export async function SetGasDataUseValue(cid, fid, { useValue, building, doorPlate, floor }, options = {}) {
  return await this._post(`/community/${cid}/gas/${fid}/value?v=${useValue}&b=${building}&d=${doorPlate}&f=${floor}`, null, options);
}

/**
 * @function ApiClient#GetGasDataExportXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fid
 */
export function GetGasDataExportXlsFileUrl(cid, fid) {
  return `${this._url}/community/${cid}/gas/${fid}/export`;
}
